import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal-margin',
  standalone: false,
  templateUrl: './confirmation-modal-margin.component.html',
  styleUrls: ['./confirmation-modal-margin.component.scss']
})
export class ConfirmationModalMarginComponent implements OnInit {
  message: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
